<template>
  <div class="limit">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'角色权限'}]"></breadcrumb>
    <div class="limit-wrap">
      <div class="limit-contain">
        <user-top-nav>
          <el-button @click="addRole()"
                     type="primary">
            <font-awesome-icon :icon="['fas', 'user-plus']" />
            <span style="margin-left:5px; font-size:14px;">创建角色</span>
          </el-button>
        </user-top-nav>
        <div class="limit-role_wrap">
          <div v-for="(item,index) in roleList"
               :key="item.id"
               class="limit-role"
               @click="editRole(index)">
            <div class="limit-role_icon">
              <font-awesome-icon :icon="['fas', 'user']"
                                 size="4x" />
            </div>
            <div class="limit-role_name">{{item.role.name}}</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog width="336px" class="role-dialog"
               title="创建角色"
               :visible.sync="roleFormVisible">
      <el-form label-position="top"
               :model="roleForm">
        <el-form-item label="角色名称">
          <el-input v-model="roleForm.role.name"
                    placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="模块权限">
          <el-tree :default-checked-keys="roleForm.menuList"
                   ref="tree"
                   node-key="id"
                   show-checkbox
                   :data="$store.state.menuList"
                   :props="{label:'name',children:'children'}"></el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submit()">提 交</el-button>
        <el-button @click="roleFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/servies/axios'
import api from '@/servies/api'
import breadcrumb from '@/components/breadcrumb'
import userTopNav from '@/components/userTopNav'
export default {
  components: {
    breadcrumb,
    userTopNav,
  },
  data() {
    return {
      roleList: [],
      roleFormVisible: false,
      roleForm: {}
    }
  },
  created() {
    this.initForm()
    this.getRoleList()
  },
  methods: {
    //表单清空
    initForm() {
      this.roleForm = {
        role: { name: '' },
        menuList: []
      }
    },
    getRoleList() {
      axios
        .post(api.roleListWithMenuList)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取角色列表成功', res.data.result)
            this.roleList = res.data.result
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
    addRole() {
      this.initForm()
      this.roleFormVisible = true
    },
    editRole(index) {
      this.roleForm.role = this.roleList[index].role
       console.log(this.roleForm.role)
      this.roleForm.menuList = this.roleList[index].menuList.map(item => {
        return item.id
      })
      this.roleFormVisible = true
    },
    submit() {
      if (this.roleForm.role.id) {
        this.roleForm.isAdd = false
      } else {
        this.roleForm.isAdd = true
      }
      let params = {
        isAdd: !this.roleForm.role.id,
        menuIdList: this.$refs.tree.getCheckedNodes(false, true).map(item => {
          return item.id
        }),
        role: this.roleForm.role
      }
      console.log(params)
      axios
        .post(api.addOrUpdateRole, params)
        .then(res => {
          if (res.data.code === 0) {
            this.roleFormVisible = false
            this.$message({
              message: '创建角色成功',
              type: 'success'
            })
            this.getRoleList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试')
        })
    }
  }
}
</script>

<style lang="scss">
.limit {
  .limit-wrap {
    padding: 77px 30px 0px 30px;
    .limit-contain {
      border-radius: 4px;
      background: #fff;
      border: 1px solid rgba(230, 227, 227, 1);
      .limit-role_wrap {
        padding: 48px;
        padding-right: 0px;
        display: flex;
        flex-wrap: wrap;
        .limit-role {
          cursor: pointer;
          margin-right: 40px;
          margin-bottom: 40px;
          height: 150px;
          width: 150px;
          border-radius: 4px;
          border: 1px solid rgba(220, 223, 230, 1);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #dcdfe6;
          flex-direction: column;
          &:hover {
            background: rgba(255, 240, 231, 1);
            color: #f0722b;
            .limit-role_name {
              color: #f0722b;
            }
          }
          .limit-role_name {
            margin-top: 8px;
            color: #4a4a4a;
          }
        }
      }
    }
  }
}
.role-dialog {
  .el-form-item {
    margin-bottom:  0px;
    .el-form-item__label {
      margin-top: 33px;
      font-size: 14px;
      line-height: 20px;
      color: #4a4a4a;
    }
  }
  .el-dialog__header {
    color: #4a4a4a;
    font-weight: 600;
    font-size: 18px;
  }
  .el-dialog__body {
    padding-top: 6px;
    padding-bottom: 0px;
  }
  .el-dialog__footer {
    //padding-top: 0px;
    text-align: left;
    .el-button {
      width: 88px;
    }
  }
}
</style>
